import { defineStore } from 'pinia';

export const useErrorStore = defineStore('error', () => {
  const errorMessage = ref('');
  const showError = ref(false);

  function setError(message: string) {
    errorMessage.value = message;
    showError.value = true;
  }

  function clearError() {
    errorMessage.value = '';
    showError.value = false;
  }

  return {
    errorMessage,
    showError,
    setError,
    clearError,
  };
});